import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { makeAccEmpData } from '../../utils/balance-accounts';
import EmployeeAccountsTable from '../../components/groups-accounts/EmployeeAccountsTable';

const EmployeeAccountsContainer = ({
  selectedYear,
  selectedUser,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const onLoadData = () => {
    setLoading(true);
    const loadedData = makeAccEmpData();
    
    setData(loadedData);
    setLoading(false);
  };

  useEffect(() => {
    onLoadData();
  }, [selectedYear, selectedUser]);

  const content = loading ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  ) : (
    <EmployeeAccountsTable
      data={data || []}
      loading={loading}
      tableRef={tableRef}
    />
  );

  return content;
};

export default EmployeeAccountsContainer;
